// extracted by mini-css-extract-plugin
export default {"selected_wrapper":"CarAdminnistrattion_selected_wrapper__HKw14","shimmer":"CarAdminnistrattion_shimmer__zCfYD"};